import { Text } from 'grommet'
import React from 'react'

const SecondaryText = ({ children, ...props }) => {
  return (
    <Text size="small" color="darkTint" {...props}>
      {children}
    </Text>
  )
}

export default SecondaryText
